"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeFormControlPhoneNumberStyling = function (_a) {
    var isAnswered = _a.isAnswered;
    var theme = (0, react_1.useTheme)();
    return (0, react_1.css)({
        width: '100%',
        '& .MuiInputLabel-shrink': {
            marginLeft: 87,
        },
        '& .MuiInputBase-root input': {
            left: 71,
            width: 'calc(100% - 71px)',
            paddingLeft: '1.2rem !important',
        },
        '& .iti__flag-container': __assign({ borderRight: "".concat(theme.mvf.border.width.thin, "px solid ").concat(theme.mvf.palette.component.answerUnselectedColor), '& .iti__selected-flag': {
                paddingLeft: theme.mvf.spacing.smedium,
                paddingRight: theme.mvf.spacing.smedium,
            } }, (isAnswered && {
            borderRight: "".concat(theme.mvf.border.width.thin, "px solid ").concat(theme.mvf.palette.component.answerSelectedColor),
        })),
        '& .Mui-error .iti__flag-container': {
            borderRight: "".concat(theme.mvf.border.width.thin, "px solid ").concat(theme.mvf.palette.status.error),
        },
        '&:hover .Mui-error .iti__flag-container': {
            borderRight: "".concat(theme.mvf.border.width.thin, "px solid ").concat(theme.mvf.palette.status.error),
        },
        '& .Mui-focused .iti__flag-container': {
            borderColor: theme.mvf.palette.component.answerSelectedColor,
        },
        '&:hover .iti__flag-container': {
            borderColor: theme.mvf.palette.component.answerSelectedColor,
        },
        '& .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag': {
            backgroundColor: (0, material_1.lighten)(theme.mvf.palette.component.answerSelectedColor, theme.mvf.filters.lighten.extreme),
        },
        '& .MuiInputBase-root.MuiInputBase-formControl': {
            width: '100%',
        },
        '& .iti--allow-dropdown': {
            width: '100%',
            position: 'unset',
        },
    });
};
exports.default = makeFormControlPhoneNumberStyling;
//# sourceMappingURL=makeFormControlPhoneNumberStyling.js.map